import { BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const ContainerProgressTracker = styled.div``;

const Line = styled.div`
	width: 2px;
	height: 50%;
	border-radius: ${BorderRadius.XXS}px;
	background-color: #1b81f5;
`;

export { ContainerProgressTracker, Line };
